import { inject } from '@core/di/di-utils';

import { DI_TOKENS } from '@shared/constants/di';
import { ICommentsService } from '@shared/types/services/comments';

export class HeaderViewModel {
  private commentsService = inject<ICommentsService>(DI_TOKENS.commentsService);

  delete: ICommentsService['delete'] = (...args) => {
    return this.commentsService.delete(...args);
  };
}
